(function () {
/**
 * AJAX for Posts Index (Archive) Module
 *
 * @package Mythril
 */ /* global mythrilPostsIndex */ (function($) {
    'use strict';
    /**
	 * Read the current filter state from the archive form.
	 *
	 * @param {JQuery} $root Archive root element.
	 * @return {{search: string, orderby: string, topic: string, page: number, per_page: number}}
	 */ function getState($root) {
        var $form = $root.find('[data-posts-index-form]');
        return {
            search: String($form.find('[name="posts-index-search"]').val() || $form.find('input[name="s"]').val() || '').trim(),
            orderby: String($form.find('[name="posts-index_orderby"]').val() || 'newest'),
            topic: String($form.find('[name="posts-index_topic"]').val() || $form.find('[name="posts-index_topic[]"]').val() || $root.attr('data-posts-index-topic') || ''),
            type: String($form.find('[name="posts-index_type"]').val() || $root.attr('data-posts-index-category') || ''),
            post_type: String($root.attr('data-posts-index-post-type') || 'post'),
            page: parseInt($root.attr('data-posts-index-page') || '1', 10) || 1,
            per_page: parseInt($root.attr('data-posts-index-per-page')) || 6,
            exclude: String($root.attr('data-posts-index-exclude') || ''),
            offset: parseInt($root.attr('data-posts-index-offset') || '0', 10) || 0,
            hide_excerpt: parseInt($root.attr('data-posts-index-hide-excerpt') || '0', 10) > 0,
            loop_template: String($root.attr('data-posts-index-loop-template') || 'posts-index_item')
        };
    }
    /**
	 * Fetch filtered results and update the list + pagination.
	 *
	 * @param {JQuery} $root Archive root element.
	 * @param {number} page  Page number to request.
	 * @return {void}
	 */ function fetchResults($root, page) {
        if (typeof mythrilPostsIndex === 'undefined') return;
        var state = getState($root);
        state.page = page || 1;
        var $list = $root.find('[data-posts-index-list]');
        var $pagination = $root.find('[data-posts-index-pagination]');
        var $status = $root.find('[data-posts-index-status]');
        var $numresults = $root.find('.num-results');
        $root.attr('aria-busy', 'true');
        $status.text(mythrilPostsIndex.i18n.loading);
        $.ajax({
            url: mythrilPostsIndex.ajaxUrl,
            method: 'POST',
            dataType: 'json',
            data: {
                action: mythrilPostsIndex.action,
                nonce: mythrilPostsIndex.nonce,
                search: state.search,
                orderby: state.orderby,
                topic: state.topic,
                type: state.type,
                post_type: state.post_type,
                page: state.page,
                per_page: state.per_page,
                offset: state.offset,
                exclude: state.exclude || null,
                hide_excerpt: state.hide_excerpt,
                loop_template: state.loop_template
            }
        }).done(function(response) {
            if (!response || !response.success || !response.data) {
                $status.text(mythrilPostsIndex.i18n.error);
                return;
            }
            if ($numresults.length) $numresults.html(response.data.total);
            $list.html(response.data.list_html);
            $pagination.html(response.data.pagination_html || '');
            $root.attr('data-posts-index-page', String(response.data.page || 1));
            $status.text('');
        }).fail(function() {
            $status.text(mythrilPostsIndex.i18n.error);
        }).always(function() {
            $root.attr('aria-busy', 'false');
        });
    }
    $(function() {
        var _loop = function(i) {
            var $thisRoot = $roots.eq(i);
            /**
			 * Initialized Select2 fields (topic multi-select)
			 */ var $postIndexTopicMultiSelect = $thisRoot.find('select[name="posts-index_topic[]"]');
            $postIndexTopicMultiSelect.select2({
                placeholder: 'All',
                multiple: true,
                allowClear: true,
                // minimumResultsForSearch: -1,
                selectionCssClass: ':all: grc-select2-select',
                // dropdownCssClass: ':all:',
                // selectOnClose: true,
                width: '100%'
            }).removeClass('preload-select2').show();
            $postIndexTopicMultiSelect.on('select2:opening select2:closing', function(event) {
                var $searchfield = $(this).parent().find('.select2-search__field');
                $searchfield.prop('disabled', true);
            });
            // $root.on('click,focus', 'grc-select2-select select2-search__field', function(event) {
            // 	// Optional: Prevent the click from bubbling if it's already clicking inside Select2
            // 	if ($(event.target).not('.select2-selection__clear')) {
            // 		$postIndexTopicMultiSelect.select2('open');
            // 	}
            // });
            $thisRoot.on('submit', '[data-posts-index-form]', function(event) {
                event.preventDefault();
                $thisRoot.attr('data-posts-index-page', '1');
                fetchResults($thisRoot, 1);
            });
            $thisRoot.on('change', '[name="posts-index_orderby"], [name="posts-index_topic"], [name="posts-index_topic[]"], [name="posts-index_type"]', function() {
                $thisRoot.attr('data-posts-index-page', '1');
                fetchResults($thisRoot, 1);
            });
            $thisRoot.on('click', 'button[data-posts-index-page]', function(event) {
                event.preventDefault();
                var $button = $(this);
                if ($button.prop('disabled') || $button.closest('.disabled').length) return;
                var page = parseInt($button.attr('data-posts-index-page') || '1', 10) || 1;
                $thisRoot.attr('data-posts-index-page', String(page));
                fetchResults($thisRoot, page);
                var listTop = $thisRoot.find('[data-posts-index-list]').offset();
                if (listTop && typeof listTop.top === 'number') window.scrollTo({
                    top: Math.max(0, listTop.top - 100),
                    behavior: 'smooth'
                });
            });
        };
        var $roots = $('[data-posts-index]');
        if (!$roots.length) return;
        for(var i = 0; i < $roots.length; i++)_loop(i);
    });
})(jQuery);

})();
//# sourceMappingURL=posts-index.js.map
